<template>
  <el-form ref="form" size="mini" label-position="right" label-width="170px" class="demo-ruleForm leftpad">
    <el-form-item label="最终报告：" :disabled="false">
      <el-row class="el-row" type="flex">
        <a style="width: 100%" :href="prescription" :disabled="false" v-if="true" target="_blank">
          {{ prescription }}
        </a>
      </el-row>

      <div v-if=false style="float: right">
        <el-button type="primary" class="button-color" v-if="prescription"
          @click="showPdf($event, 'finalWordRef')">展开</el-button>
      </div>
      <div>
        <embed ref="finalWordRef" :src="prescription" width="100%" height="600px" style="display:none" />
      </div>
      <el-upload class="upload-demo" :action="upload4Cospath('docx')" :on-preview="handlePreview" accept=".doc, .docx"
        :on-remove="handleRemove" :before-remove="beforeRemove" :limit="1" :on-exceed="handleExceed" :auto-upload="true"
        :on-success="(value) => uploadPdfSuccess('finalWord', value)" :file-list="fileList">
        <el-button style="margin:0px 0px 0px 0px;" size="mini" type="primary">点击上传</el-button>
      </el-upload>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" class="button-color" @click="_sendSms">发送短信
      </el-button>
      <span>{{ memo }}</span>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" size="medium" @click="_updateExamPrescription" class="fullWidth"
        v-show="!disabled">保存</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import { baseURL } from "../../api/axiosCreator";
import {
  sendSms,
  updateExamPrescription,
  updateExamState
} from "../../api/userExamService";
import { getUserExam } from "../../api/userService";
import { ExamStatesValue } from "../../utils/constants";
import { Util_updateExamState } from "../../utils/util";

export default {
  props: {
    examUuid: String,
    disabled: Boolean,
  },
  data() {
    return {
      prescription: "",
      memo: "",
      acquired: false,
    };
  },
  methods: {
    _getPrescription() {
      getUserExam(this.examUuid)
        .then((res) => {
          console.log("Prescription", res);
          if (res.data[0].prescription != "") {
            this.prescription = res.data[0].prescription;
            this.acquired = true;
            this.memo = res.data[0].memo;
          }
          else {
            this.acquired = false;
          }
        })
        .catch((e) => {
          console.log("getUserExam", e);
        });
    },
    _updateExamState(state, reloadFunc) {
      //如果已到达，则将其状态改为30:基础问询中
      Util_updateExamState(
        this.examUuid,
        state,
        updateExamState,
        reloadFunc,
        this.$message
      );
    },
    //保存 医嘱
    _updateExamPrescription() {
      let data = {
        prescription: this.prescription,
      };
      updateExamPrescription(this.examUuid, data)
        .then((res) => {
          if (res.success) {
            this._updateExamState(
              ExamStatesValue.FEED_BACK_80,
              this._getPrescription
            );
            this.$message({
              message: res.description,
              type: "success",
            });
          } else {
            this.$message({
              message: res.description,
              type: "warning",
            });
          }
        })
        .catch((e) => {
          this.$message({ message: e, type: "error" });
        });
    },
    uploadPdfSuccess(ref, res) {
      if (res.success) {
        this.$message({ message: "恭喜你，上传成功", type: "success" });
        this.prescription = res.data[0];
      } else {
        this.$message.error("上传失败，请重新上传");
      }
      return;
    },
    showPdf(e, ref) {
      let isHidden = this.$refs[ref].style.display == "none";
      if (isHidden) {
        this.$refs[ref].style.display = "block";
        e.currentTarget.textContent = "折叠";
      } else {
        this.$refs[ref].style.display = "none";
        e.currentTarget.textContent = "展开";
      }
    },
    _sendSms() {
      if (!this.prescription) {
        this.$message({
          message: "请先上传医嘱",
          type: "warning",
        });
        return;
      }

      this.$confirm("是否发送短信通知患者？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(
        () => {
          sendSms(this.examUuid)
            .then((res) => {
              if (res.success) {
                this.$message({
                  message: res.description,
                  type: "success",
                });
              } else {
                this.$message({
                  message: res.description,
                  type: "warning",
                });
              }
            })
        }
      ).catch(() => {
        this.$message({
          type: "info",
          message: "已取消发送",
        });
      });


    }
  },
  created() {
    this._getPrescription();
  },
  computed: {
    upload4Cospath() {
      return (type) => {
        return (baseURL + "/ExamService/uploadFile4Cos/" + this.examUuid + "/" + type + "/" + true);
      };
    }
  },
};
</script>

<style scoped lang=less>
.fullWidth {
  margin-top: 15px;
  width: 100%;
}

.button-color {
  background-color: #67C23A;
  border-color: #67C23A;
}
</style>